@if (question) {
<div class="w-full h-auto flex flex-col">
  <!-- Header da Questão -->
  <app-lesson-header
    icon="bi-clipboard-check"
    iconColor="text-blue-500"
    [title]="question.text"
    [subtitle]="getQuestionTypeLabel(question.type)"
    [wrapText]="true"
  >
  </app-lesson-header>

  <!-- Conteúdo da Questão -->
  <div
    class="flex-1 min-h-0 overflow-y-auto p-10 bg-gray-50 dark:bg-neutral-900"
  >
    <div class="w-full">
      <div class="content-card p-6">
        <div class="flex items-start gap-2 mb-3">
          <span class="text-sm font-medium text-gray-700 dark:text-neutral-300">
            Questão {{ question.order + 1 }}
          </span>
          <span
            class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-neutral-700 text-gray-600 dark:text-neutral-300"
          >
            {{ getQuestionTypeLabel(question.type) }}
          </span>
          <span
            class="rounded bg-[var(--color-primary-soft)] px-2 py-0.5 text-xs text-[var(--color-primary)]"
          >
            {{ question.points }} ponto{{ question.points !== 1 ? 's' : '' }}
          </span>
        </div>

        <h4 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {{ question.text }}
        </h4>

        <p class="text-sm text-blue-500 dark:text-blue-400 mb-6">
          {{ getInstructionText() }}
        </p>

        <!-- Opções de Resposta -->
        <div class="space-y-4">
          @for (option of question.options; track option.id) {
          <div
            class="w-full flex items-center justify-between rounded border border-gray-200 bg-white px-4 py-3 transition-all hover:border-[var(--color-primary-muted)]"
          >
            <div class="flex items-center gap-3 flex-1 text-left">
              <span
                class="font-medium text-gray-700 dark:text-neutral-300 min-w-[24px]"
              >
                {{ option.label }})
              </span>
              <span class="text-sm text-gray-900 dark:text-white flex-1">
                {{ option.text }}
              </span>
            </div>

            <!-- Círculo vazio (preview não interativo) -->
            <i
              class="bi bi-circle text-gray-300 dark:text-neutral-600 text-xl flex-shrink-0"
            ></i>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
} @else {
<div
  class="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
>
  <div class="text-center">
    <i
      class="bi bi-clipboard-check text-gray-400 dark:text-neutral-600 text-6xl mb-4"
    ></i>
    <p class="text-gray-500 dark:text-neutral-400">Questão não disponível</p>
  </div>
</div>
}
